import React from "react";
import { Box, Typography, Button } from "@mui/material";
import clsx from "clsx";
import expressConfig from "src/config/express.json";
import InstagramIcon from "src/assets/images/settings/instagram_logo.png";
import useStyle from "../Styles";

interface NotConnectedBoxProps {
  handleOpenInstructions: () => void;
  isCollapsed: boolean;
}

const NotConnectedBox: React.FC<NotConnectedBoxProps> = ({
  handleOpenInstructions,
  isCollapsed,
}) => {
  const { classes } = useStyle();
  const env = process.env.NODE_ENV || "development";
  const config = expressConfig[env];

  // const instagramLoginUrl = `https://www.facebook.com/v20.0/dialog/oauth?client_id=${config.facebook_app_id}&display=page&extras={"setup":{"channel":"IG_API_ONBOARDING"}}&redirect_uri=${config.INSTAGRAM_LOGIN_FLOW_REDIRECT_URL}&response_type=token&scope=instagram_basic,instagram_manage_messages,pages_show_list,pages_read_engagement,pages_manage_metadata`;

  const scopes = [
    "public_profile",
    "email",
    "pages_show_list",
    "pages_read_engagement",
    "pages_manage_metadata",
    "business_management",
    "instagram_basic",
    "instagram_manage_messages",
  ].join(",");

  const instagramLoginUrl =
    `https://www.facebook.com/v20.0/dialog/oauth` +
    `?client_id=${config.facebook_app_id}` +
    `&display=page` +
    `&extras=${encodeURIComponent(
      JSON.stringify({ setup: { channel: "IG_API_ONBOARDING" } }),
    )}` +
    `&redirect_uri=${encodeURIComponent(
      config.INSTAGRAM_LOGIN_FLOW_REDIRECT_URL,
    )}` +
    `&response_type=token` +
    `&auth_type=rerequest` +
    `&scope=${encodeURIComponent(scopes)}`;

  return (
    <Box className={clsx(classes.cardWrapper, isCollapsed && "collapsed")}>
      <Box className={clsx(classes.contentBox, isCollapsed && "collapsed")}>
        <Box
          className={clsx(classes.iconContainer, isCollapsed && "collapsed")}
        >
          <img
            src={InstagramIcon}
            alt="instagram icon"
            className={classes.igAccIcon}
          />
        </Box>

        <Typography
          variant="h6"
          className={clsx(classes.mainTitle, isCollapsed && "collapsed")}
        >
          {isCollapsed ? "Instagram" : "Connect your Instagram Account"}
        </Typography>

        {!isCollapsed && (
          <Typography className={classes.description}>
            Connect your Facebook professional account to manage your Instagram
            business profiles and messages seamlessly.
          </Typography>
        )}

        <Button
          variant="contained"
          href={instagramLoginUrl}
          className={clsx(classes.igAccConnectBtn, isCollapsed && "collapsed")}
        >
          Connect Account
        </Button>

        {!isCollapsed && (
          <Button
            variant="text"
            onClick={handleOpenInstructions}
            className={classes.howItWorksBtn}
          >
            How it works?
          </Button>
        )}
      </Box>
    </Box>
  );
};

export default NotConnectedBox;
